import { render, staticRenderFns } from "./discountTable.vue?vue&type=template&id=1eef4832"
import script from "./discountTable.vue?vue&type=script&lang=js"
export * from "./discountTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports